var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.803,
    height: 47.803,
    viewBox: "0 0 47.803 47.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_ok",
    transform: "translate(-7.099 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_alert_rojo",
    transform: "translate(-86.231 -19.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19158",
    "data-name": "Path 19158",
    d: "M117.231,23.332a23.9,23.9,0,1,0,23.9,23.9,23.929,23.929,0,0,0-23.9-23.9Zm0,43.457a19.555,19.555,0,1,1,19.555-19.555A19.579,19.579,0,0,1,117.231,66.789Z",
    transform: "translate(0)",
    fill: "#e23037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19159",
    "data-name": "Path 19159",
    d: "M328.841,140a2.174,2.174,0,0,0-2.173,2.173v15.209a2.173,2.173,0,1,0,4.345,0V142.173A2.174,2.174,0,0,0,328.841,140Z",
    transform: "translate(-211.609 -105.804)",
    fill: "#e23037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19160",
    "data-name": "Path 19160",
    d: "M331.011,375.507a2.173,2.173,0,1,1-2.173-2.173,2.173,2.173,0,0,1,2.173,2.173",
    transform: "translate(-211.607 -317.409)",
    fill: "#e23037"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoError);
export default __webpack_public_path__ + "static/media/ico_error.89549a88.svg";
export { ForwardRef as ReactComponent };